export default function allHail() {
	// This makes the checkboxes in formidable forms with a double-dash in the label output pretty or something.
	var selectors = [
		'.frm_opt_container:not(.frm_styled-container) .frm_checkbox > label',
		'.frm_opt_container:not(.frm_styled-container) .frm_radio> label',
		'.frm_styled-container > .frm_primary_label',
		'.frm_styled-container > label'
	];
	jQuery(selectors.join()).each(function () {
		const $label = jQuery(this);
		var text = $label.text().trim();
		if (text.indexOf('--') === -1) {
			return;
		}

		const parts = text.split('--');
		for (let i in parts) {
			parts[i] = parts[i].trim();
		}

		const textItems: { title: string | null, price: string | null, description: string | null } = {
			title: parts[0] ? parts[0] : null,
			price: null,
			description: null
		};

		if (parts[1]) {
			if (parts[1].indexOf('$') !== 0 && parts[2] && parts[2].indexOf('$') === 0) {
				textItems.price = parts[2];
				textItems.description = parts[1];
			} else {
				textItems.price = parts[1];
				if (parts[2]) {
					textItems.description = parts[2];
				}
			}
		} else if (parts[2]) {
			textItems.description = parts[2];
		}

		const $children = $label.children().detach();
		$label.html('').append($children);
		let restructured = "<div class='magic-restructure'>";
		if (textItems.title) {
			restructured += '<span class="title">' + textItems.title + '</span>';
		}
		if (textItems.price) {
			restructured += '<span class="price">' + textItems.price + '</span>';
		}

		if (textItems.description) {
			if (textItems.description.indexOf('#') === 0) {
				const $descriptionContent = jQuery(textItems.description);
				if ($descriptionContent.length > 0) {
					textItems.description = jQuery(textItems.description).detach().html();
				}
			}

			restructured += '<span class="description">' + textItems.description + '</span>';
		}

		restructured += '</div>';
		$label.append(jQuery(restructured));
	});

	jQuery('.frm_forms').find('.frm_primary_label, .price, td').each(function (){
		var regex = /\$\d+.\d{2}/gi;
		var price = this.innerHTML.match(regex);
		if (price){
			var priceArray = price[0].split('.');
			var replacement = '$<span class="dollars">' + priceArray[0].replace('$', '') + '</span><span class="separator">.</span><sup>' + priceArray[1] + '</sup>';
			if (!this.classList.contains('price')){
				replacement = '<span class="price">' + replacement + "</span>";
			}
		}
		this.innerHTML = this.innerHTML.replace(regex, replacement);
	});

	jQuery('.frm_forms').find('.frm_styled_table label').each(function (){
		var regex = /\((.+)\)/;
		var match = regex.exec(this.innerHTML) || null;
		if (match){
			var replacement = '<span class="pill">' + match[1] + "</span>";
			this.innerHTML = this.innerHTML.replace(regex, replacement);
		}

		regex = /Mbps/;
		match = regex.exec(this.innerHTML) || null;
		if (match){
			var replacement = '<sub>' + match[0] + "</sub>";
			this.innerHTML = this.innerHTML.replace(regex, replacement);
		}
	});

	jQuery('.frm_forms').find('input[type=radio], input[type=checkbox]').addClass('styled').after('<span>');

}